import React from 'react';

interface LatLongTooltipProps {
  content: React.ReactNode;
}

export const LatLongTooltip = ({ content }: LatLongTooltipProps) => {
  return (
    <div className="relative">
      <div className="group/icon">
        <div className="relative">
          <svg className="w-3.5 h-3.5 text-gray-500 flex-shrink-0 cursor-help" viewBox="0 0 24 24" fill="currentColor">
            <path fillRule="evenodd" d="M3 5.983C3 4.888 3.895 4 5 4h14c1.105 0 2 .888 2 1.983v8.923a1.992 1.992 0 0 1-2 1.983h-6.6l-2.867 2.7c-.955.899-2.533.228-2.533-1.08v-1.62H5c-1.105 0-2-.888-2-1.983V5.983Zm5.706 3.809a1 1 0 1 0-1.412 1.417 1 1 0 1 0 1.412-1.417Zm2.585.002a1 1 0 1 1 .003 1.414 1 1 0 0 1-.003-1.414Zm5.415-.002a1 1 0 1 0-1.412 1.417 1 1 0 1 0 1.412-1.417Z" clipRule="evenodd"/>
          </svg>
          <div className="absolute z-50 bg-white p-3 rounded-lg shadow-xl opacity-0 group-hover/icon:opacity-100 transition-opacity duration-200 border border-gray-200 mt-3 -translate-x-1/2 left-1/2 pointer-events-none" style={{ width: '400px' }}>
            <div className="text-sm text-gray-700 leading-relaxed font-normal text-left">
              {content}
            </div>
            <div className="absolute -top-[6px] left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-t border-l border-gray-200 rotate-45"></div>
          </div>
        </div>
      </div>
    </div>
  );
}; 